import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';

@Component({
    selector: 'c-list-button',
    templateUrl: './list-button.component.html',
    styleUrls: ['./list-button.component.scss'],
    imports: [SharedModule]
})
export class ListButtonComponent {
    @Input() label: string;
    @Input() subLabel: string;

    @Output() clicked = new EventEmitter<void>();

    icon = faChevronRight;

    clickHandler(): void {
        this.clicked.emit();
    }
}